import { Typography } from '@_shared/ui/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;

export const Explain = styled(Typography)`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
`;
